import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
    retrieve_warehouse_inventory_product_details: { status: "idle" },
};

export const retrieve_warehouse_inventory_product_details_Slice = createSlice({
    name: "retrieve_warehouse_inventory_product_details",
    initialState,
    reducers: {
        success_retrieve_warehouse_inventory_product_details: (state, action) => {
            state.retrieve_warehouse_inventory_product_details = { status: app_consts.SUCCESS, data: action.payload };
        },
        fail_retrieve_warehouse_inventory_product_details: (state, action) => {
            state.retrieve_warehouse_inventory_product_details = { status: app_consts.FAIL, message: action.payload };
        },
        reset_retrieve_warehouse_inventory_product_details: (state) => {
            state.retrieve_warehouse_inventory_product_details = { status: app_consts.IDLE };
        },
        loading_retrieve_warehouse_inventory_product_details: (state) => {
            state.retrieve_warehouse_inventory_product_details = { status: app_consts.LOADING };
        },
    }
});

export const { success_retrieve_warehouse_inventory_product_details, fail_retrieve_warehouse_inventory_product_details, reset_retrieve_warehouse_inventory_product_details, loading_retrieve_warehouse_inventory_product_details } = retrieve_warehouse_inventory_product_details_Slice.actions;

export default retrieve_warehouse_inventory_product_details_Slice.reducer;